




























































import { IconSize, ParagraphSize, ButtonType, AvatarSize } from '@getaccept/lib-ui';
import type { PropType } from '@vue/composition-api';
import { nextTick, onMounted, ref, defineComponent } from '@vue/composition-api';
import SearchLayout from '@getaccept/lib-shared/src/search/components/SearchLayout.vue';
import type { ChatParticipant } from '../types';
import { ChatHelper } from '../helpers';

export default defineComponent({
  components: {
    SearchLayout,
  },
  props: {
    participants: {
      type: Array as PropType<ChatParticipant[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const searchBoxRef = ref(null);
    const searchInput = ref('');

    const open = ref(false);
    const focusedIndex = ref(-1);

    const addedParticipants = ref<ChatParticipant[]>([]);
    const participantSuggestions = ref<ChatParticipant[]>(props.participants);

    const handleClear = async () => {
      focusedIndex.value = -1;
      searchInput.value = '';
      handleFocus();
      await nextTick();
      setSearchOpen(true);
    };

    const handleInput = () => {
      const searchRegex = new RegExp(`(\\W|^)${searchInput.value}`, 'i');
      participantSuggestions.value = props.participants.filter(
        option =>
          option.user?.fullName.search(searchRegex) !== -1 &&
          option.recipient?.fullName.search(searchRegex) !== -1 &&
          !addedParticipants.value.includes(option)
      );
    };

    const handleSelect = (participant: ChatParticipant) => {
      if (participant) {
        addedParticipants.value.push(participant);
        handleUpdateParticipants();
      }
    };

    const setSearchOpen = (show: boolean) => {
      open.value = show;
    };

    const removeRecipient = (participant: ChatParticipant) => {
      addedParticipants.value = addedParticipants.value.filter(
        p => p.userId !== participant.userId && p.recipientId !== participant.recipientId
      );
      emit('update-participants', addedParticipants.value);
      handleInput();
    };

    const enter = () => {
      if (!open.value) {
        setSearchOpen(true);
        return;
      }
      handleSelect(participantSuggestions.value[focusedIndex.value]);
    };

    const handleArrowUp = () => {
      if (focusedIndex.value > 0) {
        focusedIndex.value -= 1;
      }
    };

    const handleArrowDown = () => {
      if (focusedIndex.value < participantSuggestions.value.length - 1) {
        focusedIndex.value += 1;
      }
    };

    const handleUpdateParticipants = () => {
      setSearchOpen(false);
      handleClear();
      handleInput();
      emit('update-participants', addedParticipants.value);
    };

    const handleBackspace = () => {
      if (!searchInput.value && addedParticipants.value.length) {
        addedParticipants.value.pop();
        handleUpdateParticipants();
      }
    };

    const handleFocus = () => {
      searchBoxRef.value.focus();
    };

    onMounted(async () => {
      await nextTick();
      handleFocus();
      setSearchOpen(true);
    });

    return {
      open,
      searchBoxRef,
      searchInput,
      handleArrowUp,
      handleArrowDown,
      focusedIndex,
      handleBackspace,

      enter,
      handleSelect,
      setSearchOpen,
      handleClear,
      handleInput,
      removeRecipient,
      addedParticipants,
      participantSuggestions,
      handleUpdateParticipants,

      getParticipantsDetails: ChatHelper.getParticipantsDetails,
      ParagraphSize,
      IconSize,
      ButtonType,
      AvatarSize,
    };
  },
});
